module.exports = __webpack_public_path__ + "it.ab91b327d51152a44cd0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/it.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/it.svg
// module chunks = styles